// extracted by mini-css-extract-plugin
export default {"valuePropsList":"ValuePropositions_valuePropsList__4sFX3","valuePropText":"ValuePropositions_valuePropText__wB4Ma"};